import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const ItalicIcon = (props?: SvgProps) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <path
      d="M14.25 3H7.5"
      stroke="#6B7280"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.5 15H3.75"
      stroke="#6B7280"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.25 3L6.75 15"
      stroke="#6B7280"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
